// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer___O5Nl","link":"Footer_link__cSj1s","shopLink":"Footer_shopLink__FKaNW"};